import { render, staticRenderFns } from "./work.vue?vue&type=template&id=b4da8d52&"
import script from "./work.vue?vue&type=script&lang=js&"
export * from "./work.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports